import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSalaAuth } from '../../auth/SalaAuthContext';

interface RequireSalaAuthProps {
  children: React.ReactNode;
  /** Si true, exige perfil completo (asignatura). */
  requireProfile?: boolean;
}

export function RequireSalaAuth({ children, requireProfile = true }: RequireSalaAuthProps) {
  const { user, loading, profileComplete, firebaseReady } = useSalaAuth();
  const location = useLocation();

  if (!firebaseReady) {
    return (
      <div className="flex min-h-dvh items-center justify-center px-6 text-center">
        <p className="max-w-md text-sm text-[var(--sala-ink-muted)]">
          Firebase no está configurado en este entorno. Agrega las variables{' '}
          <code className="text-[var(--sala-accent)]">VITE_FIREBASE_*</code> para habilitar el login de
          Sala.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <p className="text-sm text-[var(--sala-ink-muted)]">Cargando sesión…</p>
      </div>
    );
  }

  if (!user) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (requireProfile && !profileComplete) {
    return <Navigate to={`/onboarding?returnTo=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <>{children}</>;
}
